import MKBox from "components/MKBox";
import { Container, Grid } from "@mui/material";
import Breadcrums from "components/Breadcrumbs";
import MKTypography from "components/MKTypography";
import routes from "routes";
import footerRoutes from "footer.routes";
import DefaultFooter from "components/Footers/DefaultFooter";
import DefaultNavbar from "components/Navbars/DefaultNavbar";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";

function Georeference() {
  return (
    <>
      <MKBox variant="gradient" style={{ backgroundColor: "#344767" }} shadow="sm" py={0.25}>
        <DefaultNavbar routes={routes} transparent relative light right />
      </MKBox>
      <MKBox minHeight="25rem" width="90%">
        <MKBox
          color="black"
          variant="gradient"
          p={1}
          position="relative"
          sx={{
            backgroundColor: "#FFF",
            display: "grid",
            placeItems: "Center",
            backgroundSize: "cover",
          }}
        />
        <MKBox component="section" bgColor="white" py={4}>
          <Container>
            <Grid container spacing={1} item xs={12} lg={12} mx="auto">
              <Grid item xs={4}>
                <Breadcrums
                  routes={[
                    { label: "Inicio", route: "/" },
                    { label: "Vendedores en la Vía Pública", route: "#" },
                    { label: "Vendedores", route: "#" },
                    { label: "Ubicación", route: "#" },
                  ]}
                />
              </Grid>
            </Grid>
          </Container>
        </MKBox>
        <MKBox
          component="section"
          position="relative"
          variant="contained"
          sx={{
            display: "grid",
            placeItems: "Center",
            backgroundSize: "cover",
            backgroundColor: "#FFF",
            width: "100%",
          }}
        >
          <Container>
            <MKBox p={1} position="relative">
              <MKTypography variant="h1">Ubicación</MKTypography>
            </MKBox>
            <br />
            <br />
            <Grid container spacing={2} height="auto" width="120%">
              <Grid item xs={12} sm={12} lg={5} py={2}>
                <Grid item position="relative" height="auto">
                  <TableContainer component={Paper} sx={{ borderRadius: 0 }}>
                    <Table sx={{ minWidth: 200, height: "200px", borderRadius: 0 }} size="small">
                      <TableBody>
                        <TableRow sx={{ backgroundColor: "#344767" }}>
                          <TableCell align="center">
                            <MKTypography variant="h4" color="white">
                              Zona
                            </MKTypography>
                          </TableCell>
                          <TableCell align="center">
                            <MKTypography variant="h4" color="white">
                              Manzana
                            </MKTypography>
                          </TableCell>
                          <TableCell align="center">
                            <MKTypography variant="h4" color="white">
                              Punto de Referencia
                            </MKTypography>
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: "#F0F2F5" }}>
                          <TableCell align="center" rowSpan="2">
                            <MKTypography variant="h4">A</MKTypography>
                          </TableCell>
                          <TableCell align="center" sx={{ padding: "5px 5px 5px 5px" }}>
                            A1
                          </TableCell>
                          <TableCell sx={{ padding: "5px 5px 5px 5px" }}>Parque Guzmán</TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: "#F0F2F5" }}>
                          <TableCell align="center" sx={{ padding: "5px 5px 5px 5px" }}>
                            A4
                          </TableCell>
                          <TableCell sx={{ padding: "5px 5px 5px 5px" }}>
                            Manzana de la Alcaldía
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: "#E0EBFB" }}>
                          <TableCell align="center" sx={{ padding: "5px 5px 5px 5px" }}>
                            <MKTypography variant="h4">D</MKTypography>
                          </TableCell>
                          <TableCell align="center" sx={{ padding: "5px 5px 5px 5px" }}>
                            D4
                          </TableCell>
                          <TableCell align="justify" sx={{ padding: "5px 5px 5px 5px" }}>
                            Manzana Dollar City, Centro
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: "#F0F2F5" }}>
                          <TableCell align="center" rowSpan={6} sx={{ padding: "5px 5px 5px 5px" }}>
                            <MKTypography variant="h4">F</MKTypography>
                          </TableCell>
                          <TableCell align="center" sx={{ padding: "5px 5px 5px 5px" }}>
                            F1
                          </TableCell>
                          <TableCell align="justify" sx={{ padding: "5px 5px 5px 5px" }}>
                            Manzana Papelería y libreria los ángeles
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: "#F0F2F5" }}>
                          <TableCell align="center" sx={{ padding: "5px 5px 5px 5px" }}>
                            F2
                          </TableCell>
                          <TableCell align="justify" sx={{ padding: "5px 5px 5px 5px" }}>
                            Manzana de Pizza Hut Centro
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: "#F0F2F5" }}>
                          <TableCell align="center" sx={{ padding: "5px 5px 5px 5px" }}>
                            F3
                          </TableCell>
                          <TableCell align="justify" sx={{ padding: "5px 5px 5px 5px" }}>
                            Manzana Banco Cuscatlan Centro
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: "#F0F2F5" }}>
                          <TableCell align="center" sx={{ padding: "5px 5px 5px 5px" }}>
                            F4
                          </TableCell>
                          <TableCell align="justify" sx={{ padding: "5px 5px 5px 5px" }}>
                            Manzana Todito
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: "#F0F2F5" }}>
                          <TableCell align="center" sx={{ padding: "5px 5px 5px 5px" }}>
                            F5
                          </TableCell>
                          <TableCell align="justify" sx={{ padding: "5px 5px 5px 5px" }}>
                            Manzana depósito de telas
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: "#F0F2F5" }}>
                          <TableCell align="center" sx={{ padding: "5px 5px 5px 5px" }}>
                            F6
                          </TableCell>
                          <TableCell align="justify" sx={{ padding: "5px 5px 5px 5px" }}>
                            Parque Gerardo Barrios
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: "#E0EBFB" }}>
                          <TableCell align="center" rowSpan="3" sx={{ padding: "5px 5px 5px 5px" }}>
                            <MKTypography variant="h4">G</MKTypography>
                          </TableCell>
                          <TableCell align="center" sx={{ padding: "5px 5px 5px 5px" }}>
                            G1
                          </TableCell>
                          <TableCell align="justify" sx={{ padding: "5px 5px 5px 5px" }}>
                            Manzana parqueo municipal
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: "#E0EBFB" }}>
                          <TableCell align="center" sx={{ padding: "5px 5px 5px 5px" }}>
                            G2
                          </TableCell>
                          <TableCell align="justify" sx={{ padding: "5px 5px 5px 5px" }}>
                            Manzana Banco Atlántida
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: "#E0EBFB" }}>
                          <TableCell align="center" sx={{ padding: "5px 5px 5px 5px" }}>
                            G3
                          </TableCell>
                          <TableCell align="justify" sx={{ padding: "5px 5px 5px 5px" }}>
                            Manzana del Banco Agrícola (cerca de Catedral)
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: "#F0F2F5" }}>
                          <TableCell align="center" sx={{ padding: "5px 5px 5px 5px" }}>
                            <MKTypography variant="h4">H</MKTypography>
                          </TableCell>
                          <TableCell align="center" sx={{ padding: "5px 5px 5px 5px" }}>
                            H11
                          </TableCell>
                          <TableCell align="justify" sx={{ padding: "5px 5px 5px 5px" }}>
                            Lavandería Lava Rápido
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: "#E0EBFB" }}>
                          <TableCell align="center" sx={{ padding: "5px 5px 5px 5px" }}>
                            <MKTypography variant="h4">I</MKTypography>
                          </TableCell>
                          <TableCell align="center" sx={{ padding: "5px 5px 5px 5px" }}>
                            I6
                          </TableCell>
                          <TableCell align="justify" sx={{ padding: "5px 5px 5px 5px" }}>
                            Manzana de Pan y Galletas Rosvill, cerca de la terminal
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: "#F0F2F5" }}>
                          <TableCell align="center" rowSpan="2" sx={{ padding: "5px 5px 5px 5px" }}>
                            <MKTypography variant="h4">J</MKTypography>
                          </TableCell>
                          <TableCell align="center" sx={{ padding: "5px 5px 5px 5px" }}>
                            J3
                          </TableCell>
                          <TableCell align="justify" sx={{ padding: "5px 5px 5px 5px" }}>
                            Manzana del agroservicio la milpa, sobre 5a calle oriente barrio el
                            calvario
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: "#F0F2F5" }}>
                          <TableCell align="center" sx={{ padding: "5px 5px 5px 5px" }}>
                            J10
                          </TableCell>
                          <TableCell align="justify" sx={{ padding: "5px 5px 5px 5px" }}>
                            Manzana Super selectos, ex cine barrios
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: "#E0EBFB" }}>
                          <TableCell align="center" rowSpan="6" sx={{ padding: "5px 5px 5px 5px" }}>
                            <MKTypography variant="h4">K</MKTypography>
                          </TableCell>
                          <TableCell align="center" sx={{ padding: "5px 5px 5px 5px" }}>
                            K1
                          </TableCell>
                          <TableCell align="justify" sx={{ padding: "5px 5px 5px 5px" }}>
                            Manzana del Continental Plaza Hotel 8a Calle Poniente # 512, San Miguel
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: "#E0EBFB" }}>
                          <TableCell align="center" sx={{ padding: "5px 5px 5px 5px" }}>
                            K2
                          </TableCell>
                          <TableCell align="justify" sx={{ padding: "5px 5px 5px 5px" }}>
                            Manzana Repuestos Excel, sobre 8a calle poniente, una cuadra después de
                            super selectos Centro
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: "#E0EBFB" }}>
                          <TableCell align="center" sx={{ padding: "5px 5px 5px 5px" }}>
                            K3
                          </TableCell>
                          <TableCell align="justify" sx={{ padding: "5px 5px 5px 5px" }}>
                            Manzana de farmacia la magnífica, sobre la 8a calle poniente, frente al
                            hotel plaza continental
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: "#E0EBFB" }}>
                          <TableCell align="center" sx={{ padding: "5px 5px 5px 5px" }}>
                            K5
                          </TableCell>
                          <TableCell align="justify" sx={{ padding: "5px 5px 5px 5px" }}>
                            ACOMI de R.L. AGENCIA CENTRAL 4a Calle Pte., San Miguel (Cerca de
                            Medalla Milagrosa)
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: "#E0EBFB" }}>
                          <TableCell align="center" sx={{ padding: "5px 5px 5px 5px" }}>
                            K9
                          </TableCell>
                          <TableCell align="justify" sx={{ padding: "5px 5px 5px 5px" }}>
                            3 avenida Sur y 1a calle poniente manzana de super tienda la cubana,
                            frente a Lacteos Medrano
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: "#E0EBFB" }}>
                          <TableCell align="center" sx={{ padding: "5px 5px 5px 5px" }}>
                            K10
                          </TableCell>
                          <TableCell align="justify" sx={{ padding: "5px 5px 5px 5px" }}>
                            Manzana de Lácteos San Francisco, 3° Avenida Sur Barrio La Merced,cerca
                            de comercial Nazaret
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} lg={7}>
                <object
                  data="//rstudio-pubs-static.s3.amazonaws.com/921184_3cf93a651f3640298d1abfa52b00a580.html"
                  type="application/pdf"
                  width="100%"
                  height="1035px"
                >
                  <p>
                    <a href="//rstudio-pubs-static.s3.amazonaws.com/921184_3cf93a651f3640298d1abfa52b00a580.html">
                      PDF FILE!
                    </a>
                  </p>
                </object>
              </Grid>
            </Grid>
          </Container>
        </MKBox>
      </MKBox>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default Georeference;
